import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { PageSectionPrimary, PageSectionSecondary, PageV2 } from 'ui/components'

import * as SC from './styles'

type ReleaseNotesData = {
  items: {
    releaseNotes: {
      notes: string[]
      period: string
    }[]
    year: number
  }[]
  totalNotes: number
}

const ReleaseNotes = () => {
  const { data, isFetching } = useQuery<ReleaseNotesData>({
    queryKey: ['release-notes'],
    queryFn: () => Request.get(Request.urls.bank.releaseNotes),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })

  return (
    <PageV2 title={'Release Notes'} face={'primary'} isPending={isFetching}>
      {data?.items.map((yearPart, index) => (
        <PageSectionPrimary
          key={index}
          title={yearPart.year}
          face={'outlined'}
          expanded={index === 0}
          foldable={true}
          contentPaddings={true}
        >
          {yearPart.releaseNotes.map((releaseNote, index) => (
            <PageSectionSecondary
              key={index}
              title={releaseNote.period}
              face={'outlined'}
              expanded={false}
              foldable={false}
              contentPaddings={true}
            >
              <SC.TextWrapper>
                <ul>
                  {releaseNote.notes.map((note, index) => (
                    <li key={index}>{note}</li>
                  ))}
                </ul>
              </SC.TextWrapper>
            </PageSectionSecondary>
          ))}
        </PageSectionPrimary>
      ))}
    </PageV2>
  )
}

export default ReleaseNotes
